import SubscriptionConfirmation from './SubscriptionConfirmation';

export default SubscriptionConfirmation;
